import { VoucherFormBanner } from '../../components/VoucherForm/Banner';
import { VoucherFormBooking } from '../../components/VoucherForm/Booking';
import { VoucherFormProvider } from '../../components/VoucherForm/Context';
import { VoucherFormDiscount } from '../../components/VoucherForm/Discount';
import { VoucherFormInformation } from '../../components/VoucherForm/Information';
import { VoucherFormQuantity } from '../../components/VoucherForm/Quantity';
import { VoucherFormStructure } from '../../components/VoucherForm/Structure';
import { VoucherFormSubmit } from '../../components/VoucherForm/Submit';

import styles from './add-voucher.module.scss';

const AddBusPartnerPage = () => {
  const VoucherFormInformationTemplate = {
    revenueType: 'Marketing',
    voucherType: 'Bus partner',
    reasonField: false,
    specificationLabel: 'Specification (bus partner free ride)',
  };

  const VoucherFormDiscountTemplate = {
    disabled: true,
    discountType: 'free_ride_marketing',
    showFreeAncillaries: true,
  };

  const VoucherFormBookingTemplate = {
    usageType: 'single',
    disableAllowedPlatforms: true,
    disableValidity: false,
    busPartnerValidity: true,
  };

  return (
    <>
      <VoucherFormBanner title='Bus partner (for bus drivers)' />
      <VoucherFormProvider>
        <form>
          <div className={styles.container}>
            <VoucherFormInformation template={VoucherFormInformationTemplate} />
            <VoucherFormQuantity />
            <VoucherFormStructure />
            <VoucherFormDiscount template={VoucherFormDiscountTemplate} />
            <VoucherFormBooking template={VoucherFormBookingTemplate} />
          </div>
          <VoucherFormSubmit />
        </form>
      </VoucherFormProvider>
    </>
  );
};

export default AddBusPartnerPage;
